module.exports = __webpack_public_path__ + "img/徐战亚.8660bafe.jpg";